import { KFormExposeApi } from "@/components/forms/Form/types";
import emitter from "tiny-emitter/instance";

export const formRegistry = new Map<string, KFormExposeApi>();

export const registerForm = ({ id, api }: { id: string; api: KFormExposeApi }) => {
    formRegistry.set(id, api);
    emitter.emit("form-registered", { id, api });
};

export const unregisterForm = ({ id }: { id: string }) => {
    formRegistry.delete(id);
    emitter.emit("form-unregistered", { id });
};
